
import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { Box, Button, Card, CardContent, CardHeader, Divider, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';

import UndoIcon from '@mui/icons-material/Undo';

import { RootState } from '../../store';
import { openSnackbar } from '../../store/slices/SnackbarSlice';

import { Layout } from '../../components/Layout';
import { ExpedienteVirtualDocumentos } from '../../components/expediente-virtual/ExpedienteVirtualDocumentos';
import { ExpedienteVirtualInformacion } from '../../components/expediente-virtual/ExpedienteVirtualInformacion';

import { ObtenerMateria } from '../../connections/catalogos/MateriaConnection';
import { ObtenerAutoridadesMaterias } from '../../connections/catalogos/AutoridadConnection';
import { ObtenerTipoConsecutivo } from '../../connections/catalogos/TipoConsecutivoConnection';
import { ObtenerExpedienteVirtual } from '../../connections/tribunal/ExpedienteVirtualConnection';

import { MateriaProps } from '../../interfaces/catalogos/MateriaInterface';
import { AutoridadProps } from '../../interfaces/catalogos/AutoridadInterface';
import { TipoConsecutivoProps } from '../../interfaces/catalogos/TipoConsecutivoInterface';
import { defaultExpedienteVirtual, ExpedienteVirtualProps } from '../../interfaces/tribunal/ExpedienteVirtualInterface';

export const ExpedienteVirtualPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [loading, setLoading] = useState( false );

    const [expedienteEncontrado, setExpedienteEncontrado] = useState( false );
    const [expedienteVirtual, setExpedienteVirtual] = useState<ExpedienteVirtualProps>( defaultExpedienteVirtual );

    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [tipoConsecutivo, setTipoConsecutivo] = useState( 0 );
    const [tipoConsecutivoArray, setTipoConsecutivoArray] = useState<TipoConsecutivoProps[]>( [] );

    const [numeroReferencia, setNumeroReferencia] = useState( '' );

    const handleBuscar = async () => {

        setLoading( true );

        await ObtenerExpedienteVirtual({ idAutoridad: autoridad, idTipoConsecutivo: tipoConsecutivo, numeroReferencia: numeroReferencia }).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    setExpedienteVirtual( resp );

                    setExpedienteEncontrado( true );

                    setLoading( false );

                }
                else {

                    setLoading( false );

                    dispatch( openSnackbar({ message, variant: 'error' }));

                }

            }, 700);

        });
    }

    const handleLimpar = () => {

        setMateria( 0 );
        setAutoridad( 0 );
        setNumeroReferencia( '' );
        setTipoConsecutivo( 0 );
        setExpedienteEncontrado( false );
        setExpedienteVirtual( defaultExpedienteVirtual );
    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then( resp => {
                setMateriaArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setAutoridad( 0 );
            setAutoridadArray( [] );

            await ObtenerAutoridadesMaterias( materia ).then( resp => {
                setAutoridadArray( resp );
            });

        }

        Obtener();

    }, [ materia ]);

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoConsecutivo().then( resp => {
                setTipoConsecutivoArray( resp );
            });

        }

        Obtener();

    }, []);

    return (
        <Layout breadcrumbs={ [{ text: 'Consultas' }, { text: 'Expediente virtual' }] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                {
                    ( administrador || coordinador )
                    &&
                        <Grid size={{ md: 12, xs: 12 }} textAlign={ 'start' }>

                            <Button startIcon={ <UndoIcon />} color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate('/') }>
                                Regresar
                            </Button>

                        </Grid>
                }

                <Grid size={{ md: 12, xs: 12 }}>

                    <Card>

                        <CardHeader
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main, py: 2 }}
                            subheader={
                                <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}>
                                    Filtro(s)
                                </Typography>
                            }
                        />

                        <Divider />

                        <CardContent sx={{ p: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 3, xs: 12 }}>

                                    <FormControl fullWidth>

                                        <InputLabel>Tipo de consecutivo</InputLabel>
                                        <Select
                                            label='Tipo de consecutivo'
                                            value={ tipoConsecutivo }
                                            onChange={ (e) => setTipoConsecutivo( parseInt( e.target.value.toString() ) ) }
                                            disabled={ expedienteEncontrado }
                                        >
                                            <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                tipoConsecutivoArray
                                                .filter( (e) => e.idTipoConsecutivo === 1 || e.idTipoConsecutivo === 2 || e.idTipoConsecutivo === 3 || e.idTipoConsecutivo === 6 )
                                                .map( (e) => (
                                                    <MenuItem key={e.idTipoConsecutivo} value={e.idTipoConsecutivo}>{ e.descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 2, xs: 12 }}>

                                    <FormControl fullWidth>

                                        <InputLabel>Materia</InputLabel>
                                        <Select
                                            label='Materia'
                                            value={ materia }
                                            onChange={ (e) => setMateria( parseInt( e.target.value.toString() ) ) }
                                            disabled={ tipoConsecutivo === 0 || expedienteEncontrado }
                                        >
                                            <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                materiaArray
                                                .filter( (e) => e.idMateria === 5 || e.idMateria === 6 )
                                                .map( (e) => (
                                                    <MenuItem key={e.idMateria} value={e.idMateria}>{ e.descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 5, xs: 12 }}>

                                    <FormControl fullWidth>

                                        <InputLabel>Autoridad</InputLabel>
                                        <Select
                                            label='Autoridad'
                                            value={ autoridad }
                                            onChange={ (e) => setAutoridad( parseInt( e.target.value.toString() ) ) }
                                            disabled={ materia === 0 || expedienteEncontrado }
                                        >
                                            <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                autoridadArray.map( (e) => (
                                                    <MenuItem key={e.idAutoridad} value={e.idAutoridad}>{ e.descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 2, xs: 12 }}>

                                    <TextField
                                        fullWidth
                                        label='Número de referencia'
                                        placeholder={ `1/${ new Date().getFullYear() }` }
                                        autoComplete='off'
                                        value={ numeroReferencia }
                                        onChange={ (e) => setNumeroReferencia( e.target.value ) }
                                        disabled={ autoridad === 0 || expedienteEncontrado }
                                        slotProps={{
                                            inputLabel:{
                                                shrink: true
                                            }
                                        }}
                                    />

                                </Grid>

                                <Grid size={{ md: 8, xs: 6 }}>

                                    <Box>

                                        <Typography variant='subtitle2' color='text.secondary'>
                                            Ingresa un número de referencia para consultar la información.
                                        </Typography>

                                    </Box>

                                </Grid>

                                <Grid size={{ md: 4, xs: 6 }} textAlign='end'>

                                    <Button
                                        variant={ expedienteEncontrado ? 'outlined' : 'contained'}
                                        color={ expedienteEncontrado ? 'secondary' : 'primary' }
                                        sx={{ width: { md: 260, xs: '100%' } }}
                                        onClick={ () => { expedienteEncontrado ? handleLimpar() : handleBuscar() } }
                                        disabled={ autoridad === 0 || numeroReferencia === '' }
                                        loading={ loading }
                                    >
                                        { expedienteEncontrado ? 'Limpiar' : 'Buscar' }
                                    </Button>

                                </Grid>

                            </Grid>

                        </CardContent>

                    </Card>

                </Grid>

                {
                    expedienteEncontrado
                    &&
                        <>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 6, xs: 12 }}>

                                    <ExpedienteVirtualInformacion
                                        expediente={ expedienteVirtual.expediente }
                                        exhorto={ expedienteVirtual.exhortoRecibido }
                                        amparo={ expedienteVirtual.amparo }
                                        irregular={ expedienteVirtual.irregular }
                                    />

                                </Grid>

                                <Grid size={{ md: 6, xs: 12 }}>

                                    <ExpedienteVirtualDocumentos
                                        acuerdos={ expedienteVirtual.acuerdos }
                                    />

                                </Grid>

                            </Grid>

                        </>
                }

            </Grid>

        </Layout>
    );
};
